/* iurop-product-carousel — recomendados de Shopify (Apodemia)
 * En la PDP pide /recommendations/products?section_id=... (Section Rendering
 * API) y sustituye la fila por los productos relacionados. Si falla o no hay,
 * se queda el contenido server-side (colección de reserva). Escrito a mano
 * (no generado). */
(function () {
  'use strict';

  function initCarousel(root) {
    var productId = root.getAttribute('data-product-id');
    if (!productId || root.hasAttribute('data-recs-loaded')) return;

    var url =
      (root.getAttribute('data-recommendations-url') || '/recommendations/products') +
      '?section_id=' + encodeURIComponent(root.getAttribute('data-section-id')) +
      '&product_id=' + encodeURIComponent(productId) +
      '&limit=' + encodeURIComponent(root.getAttribute('data-limit') || 8) +
      '&intent=related';

    // Sin parpadeo: la fila de reserva (colección) no se enseña mientras
    // llegan los recomendados; si tardan o fallan, aparece la de reserva.
    var reveal = function () { root.classList.remove('is-recs-pending'); };
    var safety = window.setTimeout(reveal, 2500);
    fetch(url)
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var track = doc.querySelector('[data-carousel-track]');
        if (track && track.children.length > 0) {
          root.querySelector('[data-carousel-track]').innerHTML = track.innerHTML;
        }
        root.setAttribute('data-recs-loaded', '');
      })
      .catch(function () { /* se queda el fallback server-side */ })
      .then(function () { window.clearTimeout(safety); reveal(); });
  }

  function initAll() {
    document.querySelectorAll('[data-product-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-product-carousel]');
    if (root) initCarousel(root);
  });
})();
